module.exports = __webpack_public_path__ + "static/WhatsApp Image 2020-09-07 at 3.53.03 PM (5)-de274f42674a1345e6b8d0144fd4029a.jpeg";